<template lang="">
  <div>
    <ToastPrime />
    <DialogPrime
      header="EEXI Calc Logger"
      v-model:visible="displayLogger"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '75vw' }"
    >
      <template #footer>
        <ListBox :options="items" :virtualScrollerOptions="{ itemSize: 31 }" listStyle="height:400px" />
      </template>
    </DialogPrime>
    <div class="div1">
      <div class="table-display2">
        <div class="cell-display div2">
          <div class="card">
            <div class="formgrid grid">
              <div class="field col-12 md:col-2 text-left">
                <p>{{ $t("shipName") }}:</p>
                <strong>{{ ship.name }}</strong>
              </div>
              <div class="field col-12 md:col-2 text-left">
                <p>{{ $t("imoNumber") }}:</p>
                <strong>{{ ship.imo }}</strong>
              </div>
              <div class="field col-12 md:col-2 text-left">
                <p>{{ $t("shipType") }}:</p>
                <strong>{{ ship.shipType.name }}</strong>
              </div>
              <div class="field col-12 md:col-2 text-left">
                <p>{{ $t("requiredEEXI") }}:</p>
                <strong>{{ ship.requiredEEXI }}</strong>
              </div>
              <div class="field col-12 md:col-2 text-left">
                <p>GT:</p>
                <strong>{{ ship.gt }}</strong>
              </div>
              <div class="field col-12 md:col-2 text-left">
                <p>DWT:</p>
                <strong>{{ ship.dwt }}</strong>
              </div>
            </div>
            <div class="formgrid grid header_second_row">
              <div class="field col-12 md:col-2 text-left">
                <label for="lastname6">{{ $t("configName") }}</label>
                <InputTextPrime v-model="configuration.name"></InputTextPrime>
              </div>
              <div class="field col-12 md:col-4 text-left">
                <label for="lastname6" class="field col-12 md:col-12 text-left">{{ $t("configDescription") }}</label>

                <TextareaPrime
                  class="field col-12 md:col-12 text-left"
                  :autoResize="true"
                  rows="5"
                  cols="30"
                  v-model="configuration.description"
                ></TextareaPrime>
              </div>
              <div class="field col-12 md:col-2 text-left">
                <label for="lastname6">{{ $t("modifiedGT") }}</label>
                <InputTextPrime v-model="configuration.modified_gt"></InputTextPrime>
              </div>
              <div class="field col-12 md:col-2 text-left">
                <label for="lastname6">{{ $t("modifiedDWT") }}</label>
                <InputTextPrime v-model="configuration.modified_dwt"></InputTextPrime>
              </div>
              <div class="field col-12 md:col-2 text-left">
                <label>{{ $t("forceVRefCalc") }}</label>
                <SelectButton v-if="shipIsEDI()" v-model="configuration.forceVRefCalc" :options="options" />
                <SelectButton disabled="true" v-else v-model="No" :options="options" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="div3" v-if="!stateForm && configuration && ship">
      <div class="table-display">
        <div class="cell-display div2">
          <div class="card">
            <div class="formgrid grid">
              <div class="field col-12 md:col-6 text-left">
                <div class="div4">
                  <ShipPartTable fields="name,cfme,pme,sfcme" partType="MainEngineEmissions"></ShipPartTable>
                </div>
              </div>
              <div class="field col-12 md:col-6 text-left">
                <div class="div4">
                  <ShipPartTable fields="name,cfae,pae,sfcae" partType="AuxiliaryEngineEmissions"></ShipPartTable>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="formgrid grid">
              <div class="field col-12 md:col-6 text-left">
                <div class="div4">
                  <ShipPartTable fields="type,feff,peff" partType="MainEngineEnergySavings"></ShipPartTable>
                </div>
              </div>
              <div class="field col-12 md:col-6 text-left">
                <div class="div4">
                  <ShipPartTable fields="type,feff,paeeff" partType="AuxiliaryEngineEnergySavings"></ShipPartTable>
                </div>
              </div>
            </div>
          </div>

         <!-- Este botón tiene la funcionalidad de obtener los datos de los 4 componentes y procesarlos, calcular lo que se necesite--> 
         <div class="div1">
          <ButtonPrime class="p-button">{{ $t("calcEngines") }}</ButtonPrime>
         </div>

          <div class="card">
            <div class="formgrid grid">
              <div class="field col-12 md:col-12 text-left">
                <div class="div4 formgrid grid">
                  <div class="field col-12 md:col-12 text-left">
                    <h4 for="firstname6">{{ $t("factors") }}</h4>
                  </div>

                  <div class="field col-12 md:col-5 text-left mb-4">
                    <label for="firstname6">{{ $t("shipDesignEle") }} - <strong>fj</strong></label>
                    <input
                      id="firstname6"
                      v-model="configuration.fj"
                      type="text"
                      disabled="true"
                      class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    />
                  </div>
                  <div class="field col-12 md:col-1 text-left">
                    <p for="firstname6">{{ $t("fj") }}</p>
                    <CheckboxPrime v-model="configuration.fj_unapply" :binary="true" />
                  </div>
                  <div class="field col-12 md:col-5 text-left mb-4">
                    <label for="firstname6">{{ $t("capacityFactor") }} - <strong>fi</strong></label>
                    <input
                      id="firstname6"
                      v-model="configuration.fi"
                      type="text"
                      class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    />
                  </div>
                  <div class="field col-12 md:col-1 text-left">
                    <p for="firstname6">{{ $t("fi") }}</p>
                    <CheckboxPrime v-model="configuration.fi_unapply" :binary="true" />
                  </div>
                  <div class="field col-12 md:col-5 text-left mb-4">
                    <label for="firstname6">{{ $t("cubicCapacity") }} - <strong>fc</strong></label>
                    <input
                      id="firstname6"
                      v-model="configuration.fc"
                      type="text"
                      class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    />
                  </div>
                  <div class="field col-12 md:col-1 text-left">
                    <p for="firstname6">{{ $t("fc") }}</p>
                    <CheckboxPrime v-model="configuration.fc_unapply" :binary="true" />
                  </div>
                  <div class="field col-12 md:col-5 text-left mb-4">
                    <label for="firstname6">{{ $t("factorGeneral") }} - <strong>fl</strong></label>
                    <input
                      id="firstname6"
                      v-model="configuration.fl"
                      type="text"
                      class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    />
                  </div>
                  <div class="field col-12 md:col-1 text-left">
                    <p for="firstname6">{{ $t("fi") }}</p>
                    <CheckboxPrime v-model="configuration.fl_unapply" :binary="true" />
                  </div>
                  <div class="field col-12 md:col-5 text-left mb-4">
                    <label for="firstname6">{{ $t("factorSpeed") }} - <strong>fw</strong></label>
                    <input
                      id="firstname6"
                      v-model="configuration.fw"
                      type="text"
                      class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    />
                  </div>
                  <div class="field col-12 md:col-1 text-left">
                    <p for="firstname6">{{ $t("fw") }}</p>
                    <CheckboxPrime v-model="configuration.fw_unapply" :binary="true" />
                  </div>
                  <div class="field col-12 md:col-5 text-left">
                    <label for="firstname6">{{ $t("factorIce") }} - <strong>fm</strong></label>
                    <input
                      id="firstname6"
                      v-model="configuration.fm"
                      type="text"
                      class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    />
                  </div>
                  <div class="field col-12 md:col-1 text-left">
                    <p for="firstname6">{{ $t("fm") }}</p>
                    <CheckboxPrime v-model="configuration.fm_unapply" :binary="true" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="final_elements">
        <div class="image_container">
          <img src="@/assets/image1.png" class="image" />
        </div>
        <div class="formgrid grid">
          <div class="field col-12 md:col-3 text-left">
            <label for="firstname6"
              >{{ $t("shipSpeed") }} - <strong>V<sub>ref</sub></strong> (kn) ({{ configuration.vref_calc }})</label
            >
            <input
              id="firstname6"
              v-model="configuration.vref"
              type="number"
              disabled
              class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
            />
          </div>
          <div class="field col-12 md:col-3 text-left">
            <label for="firstname6">{{ $t("capacity") }} (t)</label>
            <input
              id="firstname6"
              v-model="ship.capacity"
              type="number"
              disabled
              class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
            />
          </div>
          <div class="field col-12 md:col-3 text-left">
            <label>{{ $t("requiredEEXI") }} (gCO&#8322;/t·nm) - {{ modifiedRequiredEEXILabel }}</label>
            <input
              v-model="modifiedRequiredEEXI"
              type="number"
              disabled
              class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
            />
          </div>
          <div class="field col-12 md:col-3 text-left">
            <label>{{ $t("attainedEEXI") }} (gCO&#8322;/t·nm)</label>
            <input
              v-model="configuration.attainedEEXI"
              type="number"
              disabled
              class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
            />
          </div>
          <div class="formgrid grid col-12 md:col-12">
            <div class="field col-12 md:col-6 final_button"><span></span></div>
            <div v-if="mustBeShowInfo()" class="field col-12 md:col-3 final_button">
              <ButtonPrime class="p-button" @click="showInfo(true)">{{ $t("showInfo") }}</ButtonPrime>
            </div>
            <div v-else class="field col-12 md:col-3 final_button">
              <span></span>
            </div>
            <div class="field col-12 md:col-3 final_button">
              <ButtonPrime class="p-button" @click="calculate()">{{ $t("calculate") }}</ButtonPrime>
            </div>
          </div>
          <div class="field col-12 md:col-2 final_button">
            <span></span>
          </div>
        </div>
        <div class="formgrid grid col-12 md:col-12" style="border-top: 1px solid black">
          <div class="field col-12 md:col-4 final_button">
            <span></span>
          </div>
          <div class="field col-12 md:col-2 final_button">
            <ButtonPrime class="p-button" @click="saveConfig()">{{ $t("save") }}</ButtonPrime>
          </div>
          <div class="field col-12 md:col-2 final_button">
            <ButtonPrime class="p-button" @click="cancel()">{{ $t("cancel") }}</ButtonPrime>
          </div>
          <div class="field col-12 md:col-4 final_button">
            <span></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import router from "@/router/index";
import ShipPartTable from "@/components/ShipPartTable.vue";
import ConfigurationService from "@/services/ConfigurationService";
import ShipService from "@/services/ShipService";
import ParametricTableService from "@/services/ParametricTableService";
import store from "@/store/index";
import { ToastSeverity } from "primevue/api";
import EconomicService from "@/services/EconomicService";
import { checkEconomicDataForShip } from "@/utils/utils";
import utils from "@/utils/configuration/config.js";

export default {
  data() {
    return {
      options: ["Yes", "No"],
      ship: store.getters.currentShip,
      stateForm: store.getters.stateForm,
      configurationService: null,
      date: "",
      displayLogger: false,
      items: [],
    };
  },
  components: {
    ShipPartTable,
  },
  async created() {
    //console.log(this.ship);
    ParametricTableService.getInstance().getParametricTable(utils.config.firebaseConfig.parametricVersion);
  },

  methods: {
    showInfo() {
      this.items = this.configuration.logElement;
      this.displayLogger = true;
    },
    mustBeShowInfo() {
      return this && this.configuration && this.configuration.logElement && this.configuration.logElement.length > 0;
    },
    saveConfig() {
      const errors = EconomicService.getInstance().actualizeEconomicData(store.getters.currentShip, this.configuration);
      if (errors === "") {
        this.showToast(true, "Datos económicos actualizados correctamente");
      } else {
        this.showToast(false, "Error guardando datos económicos: " + errors);
      }
      let continueSaving = errors === "";

      if (continueSaving) {
        continueSaving = this.calcRequiredEEXIModified();
        if (continueSaving) {
          const calcEEXISuccess = this.calcAttainedEEXI();
          if (calcEEXISuccess) {
            const errors = ConfigurationService.getInstance().saveConfiguration(
              store.getters.currentShip.id,
              store.getters.currentConfiguration
            );

            if (errors != "") {
              this.showToast(false, "Error guardando configuración: " + errors);
            } else {
              this.showToast(true, "Configuración salvada correctamente");
            }
          } else {
            this.showToast(
              false,
              "No se ha guardado al configuración porque no se ha podido recalcular el EEXI obtenido."
            );
          }
        } else {
          this.showToast(
            false,
            "No se ha guardado al configuración porque no se ha podido recalcular el EEXI requerido modificado."
          );
        }
      }
    },
    cancel() {
      router.push({ name: "home" });
    },
    calculate() {
      //console.log("Vamos a ver el buque a ver si tiene la parte económica. Antes de calcular:", this.ship);
      const continueCalcs = this.calcRequiredEEXIModified();
      if (continueCalcs) {
        this.calcAttainedEEXI();
      }
      //console.log("Vamos a ver el buque a ver si tiene la parte económica. Después de calcular:", this.ship);
    },
    calcRequiredEEXIModified() {
      //console.log("calcRequiredEEXIModified. Vamos a ver como está el barco", store.getters.currentShip);

      const calcRequiredEEXISuccess = ConfigurationService.getInstance().calcRequiredEEXI(
        store.getters.currentShip,
        this.configuration
      );

      let continueSaving;
      if (calcRequiredEEXISuccess == undefined) {
        this.showToast(true, "No es necesario el cálculo del EEXI requerido modificado");
        continueSaving = true;
      } else {
        const message = calcRequiredEEXISuccess
          ? "Calculado RequiredEEXI (modified) con éxito = " + store.getters.currentConfiguration.modified_required_EEXI
          : "Error en el cálculo de RequiredEEXI (modified)";
        this.showToast(calcRequiredEEXISuccess, message);
        continueSaving = calcRequiredEEXISuccess;
      }

      return continueSaving;
    },
    calcAttainedEEXI() {
      //console.log("CalcAttainedEEXI");
      const parametricTables = ParametricTableService.getInstance().getParametricTable(
        utils.config.firebaseConfig.parametricVersion
      );
      const successful = ConfigurationService.getInstance().calcAttainedValue(
        store.getters.currentConfiguration,
        store.getters.currentShip,
        parametricTables
      );
      const message = successful
        ? "Calculado AttainedEEXI con éxito = " + store.getters.currentConfiguration.attainedEEXI
        : "Error en el cálculo de AttainedEEXI";
      this.showToast(successful, message);
      return successful;
    },
    showToast(successful, message) {
      if (successful) {
        this.$toast.add({
          severity: ToastSeverity.SUCCESS,
          closable: false,
          summary: message,
          life: 3000,
        });
      } else {
        this.$toast.add({
          severity: ToastSeverity.ERROR,
          closable: false,
          summary: message,
          life: 3000,
        });
      }
    },
    disableScroll() {
      var x = window.scrollX;
      var y = window.scrollY;
      window.onscroll = function () {
        window.scrollTo(x, y);
      };
    },
    enableScroll() {
      window.onscroll = null;
    },
    shipIsEDI() {
      checkEconomicDataForShip("FormEditConfiguration.shipIsEDI", this.ship);
      return ShipService.getInstance().calcIsEEDIUsingDates(this.ship);
    },
  },
  computed: {
    configuration_edit() {
      return store.getters.stateFormConfigEdit;
    },
    configuration() {
      return store.getters.currentConfiguration;
    },
    modifiedRequiredEEXILabel() {
      const modified_gt = store.getters.currentConfiguration.modified_gt;
      const modified_dwt = store.getters.currentConfiguration.modified_dwt;
      if ((modified_gt && isFinite(modified_gt)) || (modified_dwt && isFinite(modified_gt))) {
        return "modified";
      }

      return "not modified";
    },
    modifiedRequiredEEXI() {
      const modified_gt = store.getters.currentConfiguration.modified_gt;
      const modified_dwt = store.getters.currentConfiguration.modified_dwt;
      if ((modified_gt && isFinite(modified_gt)) || (modified_dwt && isFinite(modified_gt))) {
        return store.getters.currentConfiguration.modified_required_EEXI;
      }

      return store.getters.currentShip.requiredEEXI;
    },
  },
};
</script>
<style scoped>
.table-display {
  display: table;
  width: 100%;
}

.title {
  font-size: x-large;
}

.header_second_row {
  margin-top: 20px !important;
}

.title-part {
  font-style: italic;
  font-weight: bold;
  padding: 0px 10px 0 10px;
}

.cell-display {
  display: table-cell;
}

.div1 {
  padding-bottom: 0;
  margin: 40px !important;
}

.div3 {
  padding: 2%;
  padding-top: 1em;
  padding-bottom: 13% !important;
}

.div4 {
  border-radius: 10px;
  border: 1px dashed;
  padding: 10px;
  margin-bottom: 4% !important;
}
.text-test {
  font-weight: bold !important;
}

.table-display2 {
  display: table;
  width: 100%;
}

.cell-display {
  display: table-cell;
}
#header {
  width: 11%;
  border: 1px solid;
  border-bottom: 0px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  padding: 0.5%;
  margin-left: 5% !important;
}

.field {
  padding: 10px;
}

.final_button {
  padding: 20px 0px 10px 0px !important;
}

.final_elements {
  margin-bottom: 40px !important;
  border: 2px solid black;
}

.image_container {
  padding: 20px 0px 20px 0px;
}
.image {
  width: 1800px;
}
</style>
